<template>
  <w-category-list :category-list="categoryList" @click="onClickCategory" />
</template>

<script>
  import WCategoryList from '@/components/category/Home/WCategoryList'
  import { get } from 'lodash'
  import { getEventListByType } from '@/common/util/event.util'
  import { ON_CLICK } from '@/common/event.const'
  import { EventBus } from '@/components/eventbus/EventBus'
  import { stringify, parseUrl } from 'query-string'
  import { replaceUrl } from '@/common/util/common'

  export default {
    name: 'WEventProcessor',
    components: {
      WCategoryList,
    },
    props: {
      categoryList: {
        type: Array,
        default: () => [],
      },
    },
    methods: {
      getNavigationPath(url) {
        return replaceUrl(url).replace('captvpooq://', '')
      },
      sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms))
      },
      async onShowToast(item, event) {
        this.$toast({ message: get(event, 'toastText', '') })
        await this.sleep(2000)
      },
      async onClickCategory(item) {
        const { onNavigationEvent, onClickEvent } = getEventListByType(
          get(item, 'eventList', []),
        )

        if (get(onNavigationEvent, 'toastText', '') !== '') {
          await this.onShowToast(item, onNavigationEvent)
        }
        this.eventProcessor({ onNavigationEvent, onClickEvent })
      },
      eventProcessor({ onNavigationEvent, onClickEvent }) {
        if (onClickEvent) {
          EventBus.$emit(ON_CLICK, onClickEvent)
        }
        if (onNavigationEvent) {
          const { url, query } = parseUrl(
            get(onNavigationEvent, 'url', '').replace('.html', ''),
          )
          this.$router.push(
            `/${this.getNavigationPath(url)}?${stringify(query)}`,
          )
        }
      },
    },
  }
</script>
